import Button from '@material-ui/core/Button/Button';
import { Size as DeviceSize, FeatureFlag } from '@ps/web-core-enums';
import { StarsButton, useScreenSize } from '@ps/web-shared-components';
import React, { useContext, useRef } from 'react';
import { Helmet } from 'react-helmet-async';

import { Context as NavigationContext } from '@swf/components/StarsWizard/components/Navigation/Navigation';
import useFeature from '@swf/core/hooks/useFeature';

import CloseIcon from '../../../../../../assets/icons/close.svg';
import PreviousIcon from '../../../../../../assets/icons/previous.svg';
import WelcomeMobileIcon from '../../../../../../assets/welcome-mobile.jpg';
import WelcomeIcon from '../../../../../../assets/welcome.jpg';
import ProgressBar from '../../../../../ProgressBar/ProgressBar';
import ResponsinbleGamingImage from '../../../../../ResponsibleGamingImage/ResponsibleGamingImage';
import BrandLogo from '../../BrandLogo/BrandLogo';
import type { Buttons } from '../../Header';

import { backButton, closeButton, header, image, staticHeader } from './WizardHeader.scss';

interface Props {
  buttons?: Buttons;
  backButtonDisabled: boolean;
  withImage?: boolean;
  showSGImage?: boolean;
  modal?: boolean;
  title: React.ReactNode;
  handleExitPrompt: () => void;
  handleCloseClick: () => void;
  handleBackClick: () => void;
}

const WizardHeader: React.FC<Props> = ({
  buttons,
  backButtonDisabled,
  withImage,
  showSGImage,
  modal,
  title,
  handleExitPrompt,
  handleCloseClick,
  handleBackClick
}) => {
  const { previous } = useContext(NavigationContext);
  const headerRef = useRef<HTMLHeadingElement>(null);
  const exitFlowEnabled = useFeature(FeatureFlag.SwcExitFlow);
  const showProgressBar = useFeature(FeatureFlag.SwcOnboardingProgressbar);
  const { greaterThan } = useScreenSize();

  return (
    <>
      <Helmet>{headerRef.current && <title>{headerRef.current.innerText}</title>}</Helmet>
      <>
        <div className={staticHeader}>
          <main>
            {exitFlowEnabled ? (
              <Button onClick={handleExitPrompt} style={{ padding: 0 }}>
                <BrandLogo />
              </Button>
            ) : (
              <BrandLogo />
            )}
          </main>
        </div>
        <header className={header}>
          <main>
            {withImage && (
              <img
                alt="Welcome"
                className={image}
                src={greaterThan(DeviceSize.XSmall) ? WelcomeIcon : WelcomeMobileIcon}
              />
            )}
            <StarsButton
              icon={modal ? <PreviousIcon /> : <CloseIcon />}
              onClick={handleCloseClick}
              className={modal ? backButton : closeButton}
            />
            {(buttons?.back || (!buttons && previous)) && (
              <StarsButton
                icon={<PreviousIcon />}
                disabled={backButtonDisabled}
                onClick={handleBackClick}
                className={backButton}
              />
            )}
            <h2 ref={headerRef}>{title}</h2>
          </main>
        </header>
        {showProgressBar && <ProgressBar />}
        {showSGImage && <ResponsinbleGamingImage />}
      </>
    </>
  );
};
export default WizardHeader;
